import PropTypes from 'prop-types';
import './styles.scss';

function Switch({
  className = '',
  label = '',
  checked = false,
  name = '',
  onChange,
  disabled = false,
}) {
  return (
    <div className={`ui-switch__container  ${className}`}>
      <label className={`ui-switch ${disabled ? 'opacity-50' : ''}`}>
        <input
          checked={checked}
          onChange={onChange}
          name={name}
          type='checkbox'
          disabled={disabled}
        />
        <span className='slider' />
      </label>
      {label ? (
        <span className='ui-switch-label text-sm font-normal'>{label}</span>
      ) : null}
    </div>

  );
}

Switch.propTypes = {
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string,
  label: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
  ]),
  className: PropTypes.string,
  disabled: PropTypes.bool,
};

export default Switch;
